module.exports = __webpack_public_path__ + "static/media/48361065_2308770449198133_6792481595983921152_o.eac96842.jpg";